import type { FC } from 'react';
import type { RouteObject } from 'react-router-dom';
import { useRoutes } from 'react-router-dom';
import { useFindScenariosQuery } from '@services/queries/use-find-scenarios.query.ts';

interface Props {
  routes: RouteObject[];
}

export const Routing: FC<Props> = ({ routes }) => {
  useFindScenariosQuery(); // prefetching scenarios

  return useRoutes(routes);
};
